/* eslint-disable import/no-internal-modules */
import { Component, FunctionalComponent } from 'preact'
import Button from '@insided/control/uikit/Button'
import SimpleFilterSelector from '@insided/deprecated-control/overview/filters/SimpleFilterSelector'
import Pill from '@insided/deprecated-preact-components/pills/Pill'
import PillContainer from '@insided/deprecated-preact-components/pills/PillContainer'
import Icon from '@insided/deprecated-preact-components/assets'
import { Permission, Role, RoleList } from './interfaces'
import { generateRolesSelectorOptions, getExistingRules } from './utils'

interface VisibilitySettingsProps {
  roles: RoleList
  onVisibilitySettingsChange: (selectedRoles: Role[]) => void
  existingRules?: Permission[]
}

interface VisibilitySettingsState {
  isDropdownOpen: boolean
  selectedRoles: Role[]
}

interface SelectedRolesContainerProps {
  selectedRoles: Role[]
  onRemoveSelectedRole: (roleId: number) => void
}

const SelectedRolesContainer: FunctionalComponent<SelectedRolesContainerProps> = ({
  selectedRoles,
  onRemoveSelectedRole
}) => (
  <PillContainer>
    {selectedRoles.map(({ id, label }) => (
      <Pill key={id} newStyle>
        <span>{label}</span>
        <Icon
          customClass='visibility-settings__role-dismiss'
          icon='close'
          width={16}
          height={16}
          onClick={() => onRemoveSelectedRole(id)}
        />
      </Pill>
    ))}
  </PillContainer>
)

class VisibilitySettings extends Component<VisibilitySettingsProps, VisibilitySettingsState> {
  constructor(props: VisibilitySettingsProps) {
    super(props)
    this.state = {
      isDropdownOpen: false,
      selectedRoles: []
    }

    this.removeSelectedItem = this.removeSelectedItem.bind(this)
    this.filterChangeHandler = this.filterChangeHandler.bind(this)
  }

  componentDidMount() {
    const { existingRules, roles, onVisibilitySettingsChange } = this.props
    const { mainRoles, customRoles } = roles
    if (existingRules) {
      this.setState({ selectedRoles: getExistingRules([...mainRoles, ...customRoles], existingRules) })
    }
    onVisibilitySettingsChange(this.state.selectedRoles)
  }

  removeSelectedItem(roleId: number) {
    const { onVisibilitySettingsChange } = this.props
    this.setState(
      (state) => ({
        selectedRoles: state.selectedRoles.filter(({ id }) => id !== roleId)
      }),
      () => onVisibilitySettingsChange(this.state.selectedRoles)
    )
  }

  filterChangeHandler(data: string[]) {
    const { onVisibilitySettingsChange, roles } = this.props
    const { customRoles, mainRoles } = roles
    this.setState(
      {
        selectedRoles: [...customRoles, ...mainRoles].filter((role) => data.includes(String(role.id)))
      },
      () => onVisibilitySettingsChange(this.state.selectedRoles)
    )
  }

  render() {
    const { isDropdownOpen, selectedRoles } = this.state
    const { roles } = this.props

    const selectedFilterItems = this.state.selectedRoles.map((role) => String(role.id))

    return (
      <div className='visibility-settings'>
        <p className='a-text-field--label'>Page visibility</p>
        <div className='visibility-settings__container'>
          <Button
            title='Visible to'
            size='medium'
            endIcon='chevronRight'
            className='visibility-settings__dropdown-toggle'
            onClick={() => this.setState((state) => ({ isDropdownOpen: !state.isDropdownOpen }))}
          />
          {isDropdownOpen && (
            <div className='overview__filters-box-container'>
              <div className='overview__filters-box'>
                <SimpleFilterSelector
                  id='custom_page_visibility_settings'
                  name='user roles'
                  isSearchable
                  items={generateRolesSelectorOptions(roles)}
                  selectedFilterItems={selectedFilterItems}
                  onChange={this.filterChangeHandler}
                  onClickOutside={() => this.setState({ isDropdownOpen: false })}
                />
              </div>
            </div>
          )}
          {selectedRoles.length > 0 && (
            <SelectedRolesContainer selectedRoles={selectedRoles} onRemoveSelectedRole={this.removeSelectedItem} />
          )}
        </div>
      </div>
    )
  }
}

export default VisibilitySettings
